export const RoundedBarPluginV2 = {
    id: 'roundedBar',
    beforeInit(chart: any) {
        const Chart = (chart as any).constructor;
        const originalDraw = Chart.elements.Rectangle.prototype.draw;

        Chart.elements.Rectangle.prototype.draw = function () {
            const ctx = this._chart.ctx;
            const vm = this._view;
            const opts = this._chart.options || {};
            const pluginOpts = (opts.plugins && (opts.plugins as any).roundedBar) || {};
            const radius = Number(pluginOpts.radius ?? 6);
            const allCorners = Boolean(pluginOpts.allCorners ?? false);

            const isHorizontal = vm.horizontal;
            let left: number, right: number, top: number, bottom: number, width: number, height: number;

            if (isHorizontal) {
                const x = vm.x;
                const base = vm.base as number;
                const y = vm.y;
                height = vm.height;
                top = y - height / 2;
                bottom = y + height / 2;
                left = Math.min(x, base);
                right = Math.max(x, base);
                width = right - left;
            } else {
                const y = vm.y;
                const base = vm.base as number;
                const x = vm.x;
                width = vm.width;
                left = x - width / 2;
                right = x + width / 2;
                top = Math.min(y, base);
                bottom = Math.max(y, base);
                height = bottom - top;
            }

            const maxR = Math.min(Math.abs(width), Math.abs(height)) / 2;
            const r = Math.min(radius, maxR);

            let corners = { tl: 0, tr: 0, br: 0, bl: 0 };
            if (allCorners) {
                corners = { tl: r, tr: r, br: r, bl: r };
            } else if (isHorizontal) {
                const growsRight = vm.x > vm.base;
                if (growsRight) corners = { tl: 0, tr: r, br: r, bl: 0 };
                else corners = { tl: r, tr: 0, br: 0, bl: r };
            } else {
                const growsUp = vm.y < vm.base;
                if (growsUp) corners = { tl: r, tr: r, br: 0, bl: 0 };
                else corners = { tl: 0, tr: 0, br: r, bl: r };
            }

            function roundRect(
                ctx: CanvasRenderingContext2D,
                x: number,
                y: number,
                w: number,
                h: number,
                r: { tl: number; tr: number; br: number; bl: number }
            ) {
                ctx.beginPath();
                ctx.moveTo(x + r.tl, y);
                ctx.lineTo(x + w - r.tr, y);
                ctx.quadraticCurveTo(x + w, y, x + w, y + r.tr);
                ctx.lineTo(x + w, y + h - r.br);
                ctx.quadraticCurveTo(x + w, y + h, x + w - r.br, y + h);
                ctx.lineTo(x + r.bl, y + h);
                ctx.quadraticCurveTo(x, y + h, x, y + h - r.bl);
                ctx.lineTo(x, y + r.tl);
                ctx.quadraticCurveTo(x, y, x + r.tl, y);
                ctx.closePath();
            }

            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            roundRect(ctx, left, top, width, height, corners);
            ctx.fill();
            ctx.restore();
        };
    },
};
